module.exports = __webpack_public_path__ + "static/contact-324d2bc8e00a1875a623c2959aff91b4.mp4";